import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Layout from './components/Layout';
import { LoginPage, ProfileFormPage, TermsPage } from './pages/AuthPages';
import HomePage from './pages/HomePage';
// import LibraryPage from './pages/LibraryPage';
import { EditProfilePage, ProfilePage, ReadersPage } from './pages/ProfilePages';
import { ClubsPage, DirectMessagePage, GenreChatPage, MessagesPage } from './pages/ChatPages';
import { AddBookPage, BookDetailsPage, OpenLibraryBookDetailsPage } from './pages/BookPages';
import SearchResultsPage from './pages/SearchResultsPage';
import PostDetailPage from './pages/PostDetailPage';
// import { GoalBookPage, GoalsPage } from './pages/GoalsPages';
import { Logo, Spinner } from './components/UI';
import { hasArtistProfile } from './artistProfile';

function Protected({ children, allowAnonymous = false }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="splash"><Logo compact /><Spinner label="Opening Area" /></div>;
  if (!user) return allowAnonymous ? children : <Navigate to="/login" replace />;
  if (!hasArtistProfile(profile) && location.pathname !== '/create-profile') return <Navigate to="/create-profile" replace />;
  if (hasArtistProfile(profile) && location.pathname === '/create-profile') return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return <div className="splash"><Logo compact /></div>;
  if (user) {
    return <Navigate to={hasArtistProfile(profile) ? '/' : '/create-profile'} replace />;
  }
  return children;
}

function AppRoutes() {
  return <Routes>
    <Route path="/login" element={<PublicOnly><Layout authPage><LoginPage /></Layout></PublicOnly>} />
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/membership" element={<Navigate to="/login" replace />} />
    <Route path="/create-profile" element={<Protected><ProfileFormPage /></Protected>} />
    <Route element={<Layout />}>
      <Route index element={<Protected allowAnonymous><HomePage /></Protected>} />
      <Route path="posts/:postId" element={<Protected allowAnonymous><PostDetailPage /></Protected>} />
      <Route path="search" element={<SearchResultsPage />} />
      <Route path="books/openlibrary/:workId" element={<OpenLibraryBookDetailsPage />} />
      <Route path="readers" element={<Protected><ReadersPage /></Protected>} />
      <Route path="artists" element={<Protected><ReadersPage /></Protected>} />
      <Route path="people" element={<Protected><ReadersPage /></Protected>} />
      {/* <Route path="library" element={<Protected><LibraryPage /></Protected>} /> */}
      <Route path="profile" element={<Protected><ProfilePage /></Protected>} />
      <Route path="profile/:userId" element={<Protected><ProfilePage /></Protected>} />
      <Route path="profile/edit" element={<Protected><EditProfilePage /></Protected>} />
      <Route path="messages" element={<Protected><MessagesPage /></Protected>} />
      <Route path="messages/:conversationId" element={<Protected><DirectMessagePage /></Protected>} />
      <Route path="message/user/:userId" element={<Protected><DirectMessagePage /></Protected>} />
      <Route path="clubs" element={<Protected><ClubsPage /></Protected>} />
      <Route path="clubs/:roomId" element={<Protected><GenreChatPage /></Protected>} />
      <Route path="books/add" element={<Protected><AddBookPage /></Protected>} />
      <Route path="books/:ownerId/:bookId" element={<Protected><BookDetailsPage /></Protected>} />
      {/* <Route path="goals" element={<Protected><GoalsPage /></Protected>} />
      <Route path="goal-book" element={<Protected><GoalBookPage /></Protected>} /> */}
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>;
}

export default function App() {
  return <AuthProvider><AppRoutes /></AuthProvider>;
}
